module.exports = "/fonts/materialdesignicons-webfont.woff2?7fb0e3780372f10f804513e2e0c39e78";